<template>
<div>
    <div class="title">收藏列表</div>
    <div class="collection-main">
        <van-list style="width:100%" :loading="loading" :finished="complated" :total="total" finished-text="没有更多了" @load="onLoad">
            <div class="collection" v-for="(item, index) in list" :key="index" @click="goDetail(item.productId)">
                <div>
                    <img class="cationimg" :src="item.pictureUrl" alt="" width="100%" />
                </div>
                <div style="width:100%">
                    <div class="cationtitle">{{ item.chineseName }}</div>
                    <!-- <div class="cationtext">{{ item.subTitle }}</div> -->
                    <div class="cationintegral">{{ item.integralNum }}积分</div>
                </div>
            </div>
            <div v-if="list.length <= 0" style="margin:0 auto;">
                <notData title="暂无相关商品" content="每天都给自己一个惊喜，看看其他商品吧" :img="notImg"></notData>
            </div>
        </van-list>
    </div>
</div>
</template>

<script>
import {
    collectListPage
} from "@/api/api";
import notData from "@/components/notData.vue";
export default {
    components: {
        notData,
    },
    data() {
        return {
            complated: false,
            loading: false,
            finished: false,
            notImg: require("../../../../static/images/product/not-product.png"),
            list: [],
            total: "",
            pageNum: 1,
        };
    },

    methods: {
        onLoad() {
            if (!this.loading) {
                this.loading = true; //证明正在加载中 阻断 调用onLoad
                this.getCollectListPage(); //反向loading 没在加载中 可以进入
            }
        },
        async getCollectListPage() {
            const hbscToken = this.$cookies.get("hbscToken") || sessionStorage.getItem('hbscToken') || '';
            const memberId = this.$cookies.get("memberId") || sessionStorage.getItem('memberId') || '';
            if (!hbscToken || !memberId) {
                this.complated = true;
                this.loading = false; //关闭加载
                return;
            }
            let params = {
                // "memberId": 8765,
                pageNum: this.pageNum,
                pageSize: 10,
            };

            const res = await collectListPage(params);
            if (res.code == "0000") {
                if (res.data.pageNum != this.pageNum) {
                    //返回的当前页与传入的当前页不符合 证明存在重复加载的嫌疑
                    this.pageNum = res.data.pageNum + 1;
                    return false;
                }
                this.list = this.list.concat(res.data.list); //拼接查询结果
                this.total = res.data.total; //获取最大条数
                if (this.pageNum * params.pageSize > res.data.total) {
                    //如果当前页和每页显示条数大于total证明查询结果不够12条 显示没有更多 否则 不显示
                    this.complated = true;
                } else {
                    this.complated = false;
                }
                this.pageNum = this.pageNum + 1; //当前页加一
                this.loading = false; //关闭加载
            } else {
                this.complated = true;
                this.loading = false; //关闭加载
            }
        },
        goDetail(id) {
            this.$router.push({
                path: "/productDetails?id=",
                query: {
                    id: id,
                },
            });
        },
    },

    mounted() {
        this.getCollectListPage();
    },
};
</script>

<style lang="scss" scoped>
.title {
    background: #fff;
    font-size: 30px;
    font-weight: bold;
    padding: 20px;
    text-align: center;
}

.collection-main {
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    box-sizing: border-box;
}

.collection {
    width: 90%;
    display: flex;
    box-sizing: border-box;
    margin: 20px auto;
    cursor: pointer;
}

.cationtitle {
    padding: 20px;
    color: #2283e2;
}

.cationimg {
    width: 180px;
    height: 180px;
    display: block;
}

.cationtext {
    color: #999;
    padding-left: 20px;
}

.cationtitle,
.cationtext {
    width: 380px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.cationintegral {
    color: red;
    font-size: 18px;
    text-align: right;
    padding-top: 50px;
    // padding-right: 5px;
}

.page {
    text-align: center;
}
</style>
